import React, { Component, PropsWithChildren } from 'react';
import { Button } from '../Button';
import { withModalContext } from './ModalContext';
import { IModalCloseBtnProps } from './types';

/**
 * Modal close button, has an access to Modal's onHide property
 */
export class ModalCloseBtn extends Component<PropsWithChildren<IModalCloseBtnProps>, {}> {
  public render() {
    const { label = 'Cancel' } = this.props;
    return <Button type={'button'} label={label} onClick={this.props.handleClose} />;
  }
}

/**
 * We export ModalCloseBtn as it is to support Styleguist's patterns.
 * And we export enhanced component as default for the actual usage
 * @see {@link https://react-styleguidist.js.org/docs/thirdparties.html}
 */
export default withModalContext(ModalCloseBtn);
